export const ApiEndpoint = 'http://149.28.67.66:3001/';
export const FilesEndpoint = 'http://149.28.67.66:3001/'; //'http://146.190.40.205:3001/';
export const defaultIdCompany = 1;
